// extracted by css-extract-rspack-plugin
export default {"cls1":"ReferenceReportPage-cls1_48x","cls2":"ReferenceReportPage-cls2_eyV ReferenceReportPage-cls1_48x"};